import { Sonar } from './sonar';

/** Full-block "fetching a whole page" state — the sonar sweep instead of a
 * bare spinner, so waiting for a thread/room/spot to open still feels like
 * Nearmirer rather than a loading screen. */
export function PageLoader({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex flex-col items-center gap-3 py-14">
      <Sonar className="max-w-32" />
      <p className="text-sm font-medium text-ink-faint">{label}</p>
    </div>
  );
}
